import {forwardRef, useState, useCallback} from 'react';

import styled from 'styled-components';

import {flipOnLTR} from '~/shared/theme/utils';
import ImageWithAlt from '~/shared/components/ImageWithAlt';
import FormPieInputBase from '~/shared/components/FormField/FormInput/FormPieInputBase';
import PieButton from '~/shared/theme/pie/PieButton';

import eyeHideIconUrl from './assets/eyeHide.svg';
import eyeShowIconUrl from './assets/eyeShow.svg';
import {FormInputProps} from './types';

const StyledFormPieInputBase = styled(FormPieInputBase)`
  input {
    ${({theme}) => !theme.isLTR && `
    direction: ltr;
    text-align: right;
  `}
  }
`;

const ToggleButton = styled(PieButton)`
  padding: 8px;
  ${flipOnLTR`
    margin-left: -8px;
  `}
`;

const ToggleIcon = styled(ImageWithAlt)`
  width: 20px;
  height: 20px;
`;

export type FormPiePasswordInputProps = Omit<FormInputProps, 'type'>;

const FormPiePasswordInput = forwardRef<HTMLInputElement, FormPiePasswordInputProps>((props, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleToggle = useCallback(() => {
    setShowPassword(prev => !prev);
  }, []);

  return (
    <StyledFormPieInputBase
      {...props}
      type={showPassword ? 'text' : 'password'}
      ref={ref}
      endSlot={
        <ToggleButton
          onClick={handleToggle}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
          tabIndex={-1}
          variant="ghostLarge"
          iconButton
        >
          <ToggleIcon
            src={showPassword ? eyeHideIconUrl : eyeShowIconUrl}
            alt={showPassword ? 'Hide password' : 'Show password'}
          />
        </ToggleButton>
      }
    />
  );
});

export default FormPiePasswordInput;
